import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./consultancy-process.scss";

const ConsultancyProcess = () => {
  return (
    <section className="consultancy-process">
      <Fade direction="up" duration={600} triggerOnce>
        <IntroSectionBadge
          badgeText={"COME LAVORIAMO"}
          title={"Collaborazione e Supporto Tecnico"}
          text={
            "Ogni progetto è seguito con il supporto dei professionisti più adatti, per assicurare soluzioni tecniche affidabili e risultati concreti."
          }
          bgColor={"dark"}
          icon={"gears"}
        />
      </Fade>
      <Fade direction="up" duration={1000} cascade damping={0.18} triggerOnce>
        <div className="consultancy-process__cards-list">
          <CardDefault type={"light"} cardNumber={1}>
            <IconDescription
              icon={"magnifying-glass"}
              title={"Primo Contatto"}
              text={
                "Durante il primo contatto definiamo insieme il tipo di intervento e, se necessario, coinvolgiamo studi tecnici esterni per lo sviluppo del progetto."
              }
              type={"primary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"light"} cardNumber={2}>
            <IconDescription
              icon={"screwdriver"}
              title={"Indirizzamento Tecnico"}
              text={
                "Ti mettiamo in contatto con geologi, ingegneri o studi di progettazione qualificati per sviluppare la parte tecnica."
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"light"} cardNumber={3}>
            <IconDescription
              icon={"calculator"}
              title={"Progettazione"}
              text={
                "Restiamo in contatto con i tecnici per garantire che la soluzione progettata sia applicabile in modo efficace sul campo."
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
          <CardDefault type={"light"} cardNumber={4}>
            <IconDescription
              icon={"clipboard-check"}
              title={"Realizzazione"}
              text={
                "Eseguiamo i lavori con le nostre attrezzature specializzate, assicurando la piena conformità al progetto tecnico approvato."
              }
              type={"secondary"}
              size={"medium"}
              direction="vertical"
            />
          </CardDefault>
        </div>
      </Fade>

      <div className="consultancy-process__divider" />
    </section>
  );
};

export default ConsultancyProcess;
